function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.8477 11.2305C19.387 11.2305 19.8242 10.7932 19.8242 10.2539C19.8242 9.71457 19.387 9.27734 18.8477 9.27734C18.3083 9.27734 17.8711 9.71457 17.8711 10.2539C17.8711 10.7932 18.3083 11.2305 18.8477 11.2305Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.0938 1.95312H19.8242V0.976562C19.8242 0.437207 19.387 0 18.8477 0C18.3083 0 17.8711 0.437207 17.8711 0.976562V1.95312H13.4277V0.976562C13.4277 0.437207 12.9905 0 12.4512 0C11.9118 0 11.4746 0.437207 11.4746 0.976562V1.95312H7.08008V0.976562C7.08008 0.437207 6.64287 0 6.10352 0C5.56416 0 5.12695 0.437207 5.12695 0.976562V1.95312H3.90625C1.75234 1.95312 0 3.70547 0 5.85938V21.0938C0 23.2477 1.75234 25 3.90625 25H11.377C11.9163 25 12.3535 24.5628 12.3535 24.0234C12.3535 23.4841 11.9163 23.0469 11.377 23.0469H3.90625C2.8293 23.0469 1.95312 22.1707 1.95312 21.0938V5.85938C1.95312 4.78242 2.8293 3.90625 3.90625 3.90625H5.12695V4.88281C5.12695 5.42217 5.56416 5.85938 6.10352 5.85938C6.64287 5.85938 7.08008 5.42217 7.08008 4.88281V3.90625H11.4746V4.88281C11.4746 5.42217 11.9118 5.85938 12.4512 5.85938C12.9905 5.85938 13.4277 5.42217 13.4277 4.88281V3.90625H17.8711V4.88281C17.8711 5.42217 18.3083 5.85938 18.8477 5.85938C19.387 5.85938 19.8242 5.42217 19.8242 4.88281V3.90625H21.0938C22.1707 3.90625 23.0469 4.78242 23.0469 5.85938V11.4258C23.0469 11.9651 23.4841 12.4023 24.0234 12.4023C24.5628 12.4023 25 11.9651 25 11.4258V5.85938C25 3.70547 23.2477 1.95312 21.0938 1.95312Z",
  fill: "url(#paint1_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.0918 13.1836C15.834 13.1836 13.1836 15.834 13.1836 19.0918C13.1836 22.3496 15.834 25 19.0918 25C22.3496 25 25 22.3496 25 19.0918C25 15.834 22.3496 13.1836 19.0918 13.1836ZM19.0918 23.0469C16.911 23.0469 15.1367 21.2727 15.1367 19.0918C15.1367 16.9109 16.911 15.1367 19.0918 15.1367C21.2726 15.1367 23.0469 16.9109 23.0469 19.0918C23.0469 21.2727 21.2726 23.0469 19.0918 23.0469Z",
  fill: "url(#paint2_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5078 18.1152H20.0684V17.0898C20.0684 16.5505 19.6312 16.1133 19.0918 16.1133C18.5524 16.1133 18.1152 16.5505 18.1152 17.0898V19.0918C18.1152 19.6312 18.5524 20.0684 19.0918 20.0684H20.5078C21.0472 20.0684 21.4844 19.6312 21.4844 19.0918C21.4844 18.5524 21.0472 18.1152 20.5078 18.1152Z",
  fill: "url(#paint3_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5996 11.2305C15.1389 11.2305 15.5762 10.7932 15.5762 10.2539C15.5762 9.71457 15.1389 9.27734 14.5996 9.27734C14.0603 9.27734 13.623 9.71457 13.623 10.2539C13.623 10.7932 14.0603 11.2305 14.5996 11.2305Z",
  fill: "url(#paint4_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3516 15.4785C10.8909 15.4785 11.3281 15.0413 11.3281 14.502C11.3281 13.9626 10.8909 13.5254 10.3516 13.5254C9.81222 13.5254 9.375 13.9626 9.375 14.502C9.375 15.0413 9.81222 15.4785 10.3516 15.4785Z",
  fill: "url(#paint5_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.10352 11.2305C6.64286 11.2305 7.08008 10.7932 7.08008 10.2539C7.08008 9.71457 6.64286 9.27734 6.10352 9.27734C5.56418 9.27734 5.12695 9.71457 5.12695 10.2539C5.12695 10.7932 5.56418 11.2305 6.10352 11.2305Z",
  fill: "url(#paint6_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.10352 15.4785C6.64286 15.4785 7.08008 15.0413 7.08008 14.502C7.08008 13.9626 6.64286 13.5254 6.10352 13.5254C5.56418 13.5254 5.12695 13.9626 5.12695 14.502C5.12695 15.0413 5.56418 15.4785 6.10352 15.4785Z",
  fill: "url(#paint7_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.10352 19.7266C6.64286 19.7266 7.08008 19.2893 7.08008 18.75C7.08008 18.2107 6.64286 17.7734 6.10352 17.7734C5.56418 17.7734 5.12695 18.2107 5.12695 18.75C5.12695 19.2893 5.56418 19.7266 6.10352 19.7266Z",
  fill: "url(#paint8_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3516 19.7266C10.8909 19.7266 11.3281 19.2893 11.3281 18.75C11.3281 18.2107 10.8909 17.7734 10.3516 17.7734C9.81222 17.7734 9.375 18.2107 9.375 18.75C9.375 19.2893 9.81222 19.7266 10.3516 19.7266Z",
  fill: "url(#paint9_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3516 11.2305C10.8909 11.2305 11.3281 10.7932 11.3281 10.2539C11.3281 9.71457 10.8909 9.27734 10.3516 9.27734C9.81222 9.27734 9.375 9.71457 9.375 10.2539C9.375 10.7932 9.81222 11.2305 10.3516 11.2305Z",
  fill: "url(#paint10_linear)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 18.286,
  y1: 9.27734,
  x2: 19.6194,
  y2: 9.4789,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 5.31088,
  y1: 1.04662e-06,
  x2: 22.3782,
  y2: 2.57994,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 15.6938,
  y1: 13.1836,
  x2: 23.7608,
  y2: 14.403,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 18.831,
  y1: 16.1133,
  x2: 21.1452,
  y2: 16.4113,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 14.038,
  y1: 9.27734,
  x2: 15.3713,
  y2: 9.4789,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 9.78991,
  y1: 13.5254,
  x2: 11.1233,
  y2: 13.7269,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 5.54187,
  y1: 9.27734,
  x2: 6.87525,
  y2: 9.4789,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 5.54187,
  y1: 13.5254,
  x2: 6.87525,
  y2: 13.7269,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 5.54187,
  y1: 17.7734,
  x2: 6.87525,
  y2: 17.975,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 9.78991,
  y1: 17.7734,
  x2: 11.1233,
  y2: 17.975,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 9.78991,
  y1: 9.27734,
  x2: 11.1233,
  y2: 9.4789,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default __webpack_public_path__ + "static/media/end2.4e3d29fc.svg";
export { SvgComponent as ReactComponent };